import React from 'react';
import PropTypes from 'prop-types';
import Dropzone from 'react-dropzone';
import { Button } from 'react-bootstrap';

/**
 * @PROPS :
 * @param {String || Component} button_contents - Contents of the Button
 * @param {Function} onDrop - onDrop callback
 * @param {Boolean} block - Block button or not
 * @param {String} bsStyle - Boostrap style for button
 * @param {Boolean} disabled - Disables button
 */

const SingleFileUploadButton = props => {
  let drop_zone_ref = null;
  return (
    <div>
      <Dropzone
        style={{height: '0%'}}
        onDrop={props.onDrop}
        ref={node => { drop_zone_ref = node }}
        multiple={false}
      />
      <Button
        onClick={() => drop_zone_ref.open()}
        block={props.block}
        bsStyle={props.bsStyle || 'default'}
        disabled={props.disabled == true}
        >
        {props.button_contents}
      </Button>
    </div>
  );
}

export default SingleFileUploadButton



// WEBPACK FOOTER //
// ./src/browser/components/ui/single-file-upload-button.js